/**
 * Reproduce sonidos de notificación.
 * Solo la pestaña líder (y visible) suena, para no duplicar audio.
 */
import { reportNotifDiagnostic } from '../services/notifDiagnosticService.js';

const CHANNEL_NAME = 'pb-audio-leader';
const tabId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
let isLeader = true;
let channel = null;
let audioBlockedReported = false;

const initLeaderElection = () => {
  if (typeof window === 'undefined' || channel) return;
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
    const beat = () => {
      channel.postMessage({ type: 'hello', tabId });
    };
    channel.onmessage = (event) => {
      const msg = event?.data || {};
      if (msg.type === 'hello' && msg.tabId && msg.tabId !== tabId) {
        isLeader = String(tabId) <= String(msg.tabId);
      }
      if (msg.type === 'played' && msg.notificationId) {
        recentPlayed.set(String(msg.notificationId), Date.now());
      }
    };
    beat();
    setInterval(beat, 2500);
  } catch (_error) {
    isLeader = true;
    channel = null;
  }
};

const recentPlayed = new Map();

initLeaderElection();

export function playNotification(nombreArchivo, options = {}) {
  if (!nombreArchivo) {
    console.warn('[audioUtils] No se especificó archivo de sonido');
    return Promise.resolve(false);
  }

  const force = Boolean(options.force);
  const notificationId = String(options.notificationId || options.eventId || '').trim();

  if (!force) {
    if (String(nombreArchivo).toLowerCase() === 'silence.mp3') {
      return Promise.resolve(false);
    }
    if (typeof document !== 'undefined' && document.hidden) {
      return Promise.resolve(false);
    }
    if (!isLeader) {
      return Promise.resolve(false);
    }
    if (notificationId) {
      const prev = recentPlayed.get(notificationId) || 0;
      if (Date.now() - prev < 8000) return Promise.resolve(false);
      recentPlayed.set(notificationId, Date.now());
    }
  }

  const url = `/sounds/${nombreArchivo}`;
  if (process.env.NODE_ENV !== 'production') {
    console.log('[audioUtils] Intentando reproducir sonido:', url);
  }
  const audio = new Audio(url);
  return audio.play().then(() => {
    if (notificationId && channel) {
      channel.postMessage({ type: 'played', notificationId, tabId });
    }
    if (process.env.NODE_ENV !== 'production') {
      console.log('[audioUtils] Sonido reproducido:', url);
    }
    return true;
  }).catch((err) => {
    console.warn('[audioUtils] Error al reproducir sonido:', err);
    window.dispatchEvent(new CustomEvent('pb:audio-unlock-required'));
    if (!audioBlockedReported) {
      audioBlockedReported = true;
      reportNotifDiagnostic({
        level: 'warn',
        code: 'AUDIO_BLOCKED',
        vista: 'audio',
        msg: 'autoplay bloqueado al reproducir notificación'
      });
    }
    return false;
  });
}
